//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import draggable from "vuedraggable";

export default {
  name: "MenuSetting",
  components: {
    draggable,
  },
  data() {
    return {
      loading: false,
      drag: false,
      oneLevelMenu: [],
      menuIconMap: {
        基础信息管理: require("@/assets/entrance/menu_icon01.png"),
        生产经营管理: require("@/assets/entrance/menu_icon02.png"),
        社会化服务管理: require("@/assets/entrance/menu_icon03.png"),
        生产托管服务管理: require("@/assets/entrance/menu_icon04.png"),
        智联设备管理: require("@/assets/entrance/menu_icon05.png"),
        农机作业管理: require("@/assets/entrance/menu_icon06.png"),
        订单农业生产管理: require("@/assets/entrance/menu_icon07.png"),
        智慧农业管理: require("@/assets/entrance/menu_icon08.png"),
        金融贷款服务: require("@/assets/entrance/menu_icon09.png"),
        农业保险服务: require("@/assets/entrance/menu_icon10.png"),
        生产资料服务及管理: require("@/assets/entrance/menu_icon11.png"),
        农业补贴管理: require("@/assets/entrance/menu_icon12.png"),
        应急调度管理: require("@/assets/entrance/menu_icon13.png"),
        财务管理: require("@/assets/entrance/menu_icon14.png"),
        数字化驾驶舱系统: require("@/assets/entrance/menu_icon15.png"),
      },
    };
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: "description",
        disabled: false,
        ghostClass: "ghost",
      };
    },
  },
  created() {
    this.selectOneLevelMenu();
  },
  methods: {
    /**
     * @description
     * @Author quwandong
     * @Date 2023-10-17 21:05:38
     */
    onSelectAllBtnClick() {
      this.oneLevelMenu = this.oneLevelMenu.map((item) => ({
        ...item,
        enable: 2,
      }));
    },
    /**
     * @description: 获取一级菜单（入口各子系统）
     * @Author: juanjuanhui
     * @Date: 2023-02-25 17:50:10
     */
    async selectOneLevelMenu() {
      try {
        this.loading = true;
        let { data } = await this.$http.common.selectOneLevelMenu({
          masterId: this.$route.query.masterId,
          systemType: 3,
        });

        this.oneLevelMenu = data
          ? data
              .slice(0, 15)
              .sort((a, b) => (a.sort > b.sort ? 1 : -1))
              .map((item) => ({
                ...item,
                enable: item.enable === null ? 3 : item.enable,
              }))
          : [];
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
    /**
     * @description
     * @Author quwandong
     * @Date 2023-10-17 19:38:45
     */
    async onSaveBtnClick() {
      try {
        const params = this.oneLevelMenu.map((item, index) => ({
          menuId: item.menuId,
          enable: item.enable,
          sort: index,
        }));
        this.loading = true;

        await this.$http.common.updateModule({
          masterId: this.$route.query.masterId,
          moduleList: params,
        });
        this.$message.success("保存成功");
        setTimeout(() => {
          this.$router.go(-1);
        }, 300);
      } catch (e) {
        console.log(e);
      } finally {
        this.loading = false;
      }
    },
  },
};
